<p-confirmDialog />
<div *ngIf="!loading">
  <div class="department-filter mb-3">
    <label class="block mb-2 text-sm text-color-secondary" for="departmentFilter">Department</label>
    <p-multiSelect
      inputId="departmentFilter"
      [options]="departmentOptions"
      [(ngModel)]="selectedDepartments"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      filterPlaceholder="Search department..."
      [placeholder]="departmentFilterPlaceholder"
      display="chip"
      [showClear]="false"
      [showToggleAll]="true"
      appendTo="body"
      styleClass="w-full"
      (onChange)="onDepartmentChange($event)">
    </p-multiSelect>
  </div>
  <div class="grid user-summary-cards mb-3">
    <div class="col-12 md:col-6 lg:col" *ngFor="let card of userSummaryCards">
      <div class="user-summary-card">
        <div class="flex align-items-start gap-3">
          <div class="user-summary-icon flex align-items-center justify-content-center" [ngClass]="card.iconClass">
            <i-tabler class="ti-normal ti-lg" [name]="card.icon"></i-tabler>
          </div>
          <div class="flex-grow-1">
            <div class="text-sm text-color-secondary">{{ card.label }}</div>
            <div class="user-summary-value mt-1">{{ card.value }}</div>
          </div>
        </div>
        <div class="flex justify-content-between align-items-end mt-3">
          <span class="text-sm text-color-secondary">{{ card.subtext }}</span>
          <svg class="user-summary-sparkline" [ngClass]="card.iconClass" viewBox="0 0 72 24" aria-hidden="true">
            <polyline fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              points="0,18 12,14 24,16 36,8 48,12 60,6 72,10" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</div>
<app-skeleton  id="table-items" *ngIf="loading" [columns]="tableConfig" [paginator]="true"></app-skeleton>
<div class="table-responsive" *ngIf="!loading">
    <app-primeng-table 
      [tableData]="displayedTableData" 
      [columns]="tableConfig" 
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="10"
      [responsiveLayout]="'scroll'"
      [styleClass]="'p-datatable-gridlines'"
      [isFilterRequired]="true"
      [customTemplates]="{'action': action, 'status': status, 'online': online, 'roleNames': roleNames, 'applicationNames': applicationNames, 'moduleNames': moduleNames}"
    >
    </app-primeng-table>
    <ng-template #status let-rowData="rowData" let-index="index">
      <td>
        <span class="font-weight-bold"
         [ngClass]="rowData?.status === 'Active' ? 'text-success':'text-red-500'" >{{rowData?.status}}</span>
      </td>
    </ng-template>
    <ng-template #online let-rowData="rowData" let-index="index">
      <td>
        <span class="font-weight-bold"
         [class.text-green-500]="rowData?.online === 'Online'"
         [class.text-red-500]="rowData?.online === 'Offline'">{{rowData?.online ?? '-'}}</span>
      </td>
    </ng-template>

    <ng-template #roleNames let-rowData="rowData">
      <td>
        <div class="chips  flex gap-1 flex-wrap">
          <ng-container *ngFor="let row of rowData.applicationRolesDetailsList; let i = index">
            @if(row.roleName) {
              <p-chip  pTooltip="{{row.roleName}}" 
                tooltipPosition="top"  [label]="row.roleName | truncate:10"></p-chip>
            }
            @else {
              -
            }
          </ng-container>
        </div>
      </td>
    </ng-template>
    <ng-template #applicationNames let-rowData="rowData">
      <td>
        <div class="chips flex gap-1 flex-wrap">
          <ng-container *ngFor="let row of rowData.applicationRolesDetailsList; let i = index">
            @if (row.applicationName) {
              <p-chip  pTooltip="{{row.applicationName}}" 
                  tooltipPosition="top"  [label]="row.applicationName | truncate:10"></p-chip>
            }
            @else {
              -
            }
          </ng-container>
        </div>
      </td>
    </ng-template>
    <ng-template #moduleNames let-rowData="rowData">
      <td>
        <div class="chips flex gap-1 flex-wrap">
          <ng-container *ngIf="rowData.moduleDisplayList?.length; else noModule">
            <p-chip *ngFor="let moduleName of rowData.moduleDisplayList"
              pTooltip="{{moduleName}}"
              tooltipPosition="top"
              [label]="moduleName | truncate:10">
            </p-chip>
          </ng-container>
          <ng-template #noModule>-</ng-template>
        </div>
      </td>
    </ng-template>
    <ng-template #action let-rowData="rowData" let-rowIndex="rowIndex">
      <td>
        <div class="flex">
          <p-button *ngIf="isEditPermission" size="small" pTooltip="edit" (onClick)="handleOptionClick(rowData,'Edit')" [text]="true" [raised]="false" severity="secondary">
            <i-tabler class="ti-normal ti-lg" name="edit"></i-tabler>
          </p-button>
          <p-button size="small" pTooltip="View" (onClick)="handleOptionClick(rowData,'View')" [text]="true" [raised]="false" severity="secondary">
            <i-tabler class="ti-normal ti-lg" name="eye"></i-tabler>
          </p-button>
          <p-button *ngIf="isEditPermission" size="small" pTooltip="Delete" (onClick)="handleOptionClick(rowData,'Delete')" [text]="true" [raised]="false" severity="secondary">
            <i-tabler class="ti-normal ti-lg " name="trash"></i-tabler>
          </p-button>
        </div>
      </td>
    </ng-template>

</div>
